import {cx} from "@emotion/css";
import {ReactComponent as SvgVisibility} from "assets/svg/visibility.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmVisibilityIcon: React.FC<IIconBase> = ({id, size = "lg", color = designColors.black, className}) => {
  return <SvgVisibility id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
